export default {
  reviewMain: {
    id: 'review_main_title',
    defaultMessage: 'Value for money',
  },
  reviewAccessories: {
    id: 'review_accessories_title',
    defaultMessage: 'Accessories',
  },
  reviewAestheticAppearance: {
    id: 'review_aesthetic_appearance_title',
    defaultMessage: 'Outside Appearance',
  },
  reviewBattery: {
    id: 'review_battery_title',
    defaultMessage: 'Battery',
  },
  reviewCamera: {
    id: 'review_camera_title',
    defaultMessage: 'Lens & Camera',
  },
  reviewOverallPerformance: {
    id: 'review_overall_performance_title',
    defaultMessage: 'Overall performance',
  },
  reviewPackagingCleanliness: {
    id: 'review_packaging_cleanliness_title',
    defaultMessage: 'Packaging and cleanliness',
  },
  reviewShipping: {
    id: 'review_shipping_title',
    defaultMessage: 'Shipping',
  },
  showMore: {
    id: 'reviews_rating_categories_show',
    defaultMessage: 'See all rating categories',
  },
  showLess: {
    id: 'reviews_rating_categories_hide',
    defaultMessage: 'Hide rating categories',
  },
}
